import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div style={{ overflow: 'hidden', height: '100dvh', width: '100vw', position: 'fixed', top: 0, left: 0 }}>
    <App />
  </div>
);

